/**
 * Icons by name, so packs (plain data) can name one. The set is bundled (lucide-react): the totem
 * works offline. To add an icon: import it and add a line to ICONS.
 */
import {
  ALargeSmall, AlignCenter, Accessibility, ArrowLeft, ArrowRight, Armchair, Baby, Banknote, Bike, Bot, Brain, Calendar, Check, ChevronDown, ChevronLeft,
  ChevronRight, ChevronUp, CircleCheck, CircleHelp, Clock, CornerDownLeft, CreditCard, Delete, Dog, Ear, Euro, Eye, Globe, Hand,
  Headset, Info, Keyboard, Landmark, LayoutDashboard, LoaderCircle, Map as MapIcon, Mic, MicOff, Minus, Monitor, Moon, Pause, Pencil,
  Play, Plus, QrCode, Radio, RotateCcw, ScanLine, Search, SendHorizontal, Settings, SkipBack, SkipForward, SlidersHorizontal,
  AppWindow, Blocks, Contrast, Copy, Image, Orbit, PanelTop, Shapes, Frame, Highlighter, History, MessagesSquare, MoveHorizontal, Palette, ToggleRight,
  Sparkles, Square, Sun, StepBack, StepForward, Ticket, TrainFront, TriangleAlert, Type, User, Users, Volume2, Wallet, Wifi, WifiOff, X,
  ChartPie, HandCoins, Luggage, PlugZap, Snowflake, TramFront, Utensils,
  type LucideIcon,
} from 'lucide-react';
import { reportOnce } from '../core/diagnostics';

export const ICONS: Record<string, LucideIcon> = {
  accessibility: Accessibility, back: ArrowLeft, next: ArrowRight, seat: Armchair, child: Baby, cash: Banknote,
  bike: Bike, assistant: Bot, brain: Brain, calendar: Calendar, check: Check, prev: ChevronLeft, more: ChevronRight, 'chevron-up': ChevronUp, 'chevron-down': ChevronDown,
  done: CircleCheck, help: CircleHelp, clock: Clock, enter: CornerDownLeft, card: CreditCard, delete: Delete, dog: Dog,
  ear: Ear, euro: Euro, eye: Eye, language: Globe, hand: Hand, operator: Headset, info: Info, keyboard: Keyboard,
  bank: Landmark, layout: LayoutDashboard, loading: LoaderCircle, map: MapIcon, mic: Mic, 'mic-off': MicOff, minus: Minus,
  screen: Monitor, moon: Moon, sun: Sun, pause: Pause, edit: Pencil, play: Play, plus: Plus, qr: QrCode, live: Radio, restart: RotateCcw,
  scan: ScanLine, search: Search, send: SendHorizontal, settings: Settings, 'skip-back': SkipBack, 'skip-forward': SkipForward,
  filter: SlidersHorizontal, sparkles: Sparkles, stop: Square, 'step-back': StepBack, 'step-forward': StepForward,
  ticket: Ticket, train: TrainFront, warning: TriangleAlert, text: Type, user: User, users: Users, wallet: Wallet,
  online: Wifi, offline: WifiOff, close: X,
  // a journey's details: a class, a price, a coach, what is on board
  class: ChartPie, price: HandCoins, coach: TramFront, luggage: Luggage, plug: PlugZap, wifi: Wifi, food: Utensils, cooling: Snowflake,
  // Settings
  'text-size': ALargeSmall, align: AlignCenter, parts: Blocks, contrast: Contrast, frame: Frame, highlight: Highlighter,
  history: History, chat: MessagesSquare, speaker: Volume2, 'panel-top': PanelTop, 'app-window': AppWindow,
  orbit: Orbit, shapes: Shapes, image: Image, copy: Copy, width: MoveHorizontal, palette: Palette, toggles: ToggleRight,
};

export function Icon({ name, size = 32, strokeWidth = 2.2, className }: {
  name: string;
  size?: number;
  strokeWidth?: number;
  className?: string;
}) {
  const Svg = ICONS[name];
  if (!Svg) {
    reportOnce('warn', 'ui-kit', `unknown icon "${name}"`);
    return <CircleHelp size={size} strokeWidth={strokeWidth} className={className} aria-hidden />;
  }
  return <Svg size={size} strokeWidth={strokeWidth} className={className} aria-hidden />;
}
